// ============================================
// STAT CARD — the admin dashboard's KPI treatment, shared
// ============================================
// Deliberately the SAME visuals as the office dashboard's KPI strip — the coloured accent bar, the
// soft gradient tint and the icon chip — so the portals feel like one product.
//
// `onClick` is optional: when given, the whole card behaves as a button (which is how the client
// portal's cards navigate).

const NAVY = '#0A1929';

export default function StatCard({ label, value, sub, icon, accent = '#00A86B', subColor, title, onClick }) {
  const body = (
    <>
      <span className="absolute inset-x-0 top-0 h-0.5" style={{ backgroundColor: accent }} />
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wide" style={{ color: '#64748B' }}>{label}</p>
        <span
          className="w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0"
          style={{ backgroundColor: `${accent}1F`, color: accent }}
        >
          {icon}
        </span>
      </div>
      <p className="text-2xl font-bold mt-2" style={{ color: NAVY }}>{value}</p>
      {sub && <p className="text-xs mt-1" style={{ color: subColor || '#64748B' }}>{sub}</p>}
    </>
  );

  const className = 'rounded-xl border shadow-sm p-4 relative overflow-hidden text-left w-full transition-shadow hover:shadow-md';
  const style = {
    borderColor: '#E8ECEF',
    background: `linear-gradient(160deg, #FFFFFF 0%, ${accent}0F 100%)`
  };

  if (onClick) {
    return (
      <button type="button" onClick={onClick} title={title} className={className} style={style}>
        {body}
      </button>
    );
  }

  return <div title={title} className={className} style={style}>{body}</div>;
}
